import {
  Component,
  Input,
  Output,
  EventEmitter,
  Inject,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';

import { IS_BROWSER } from '@app/modules/core/tokens/app.tokens';
import { SwipeType } from '@ux/entities/swipe-types.enum';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';
import { BorderRadiusDsType, NoneBorderRadiusDs, SwipeBorderRadiusDs } from '@design-system/entities/border-radius.type';
import {
  TypographyFontFamily, TypographyFontSize, TypographyColor
} from '@design-system/components/atoms/typography/entities/typography.types';
import { HeaderWidgetConfig, HeaderWidgetType } from '@design-system/components/templates/header/entities/header.types';

@Component({
  selector: 'app-swipe-up',
  templateUrl: './swipe-up.component.html',
  styleUrls: ['./swipe-up.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SwipeUpComponent implements OnChanges {

  @Input() height: number = 50;
  @Input() heightPercentaje: number = 0;
  @Input() overflowY?: string;
  @Input() showSwipeUp = false;
  @Input() classType: SwipeType = SwipeType.NONE;
  @Input() useBackground = true;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() showHeader = false;
  @Input() showFooter = false;

  @Output() toggleShowSwipeUp: EventEmitter<Event> = new EventEmitter<Event>();

  public isActive = false;
  public fadeOut = false;

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;

  constructor(
    @Inject(IS_BROWSER) public isBrowser: boolean,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly domManipulateService: DomManipulateService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showSwipeUp) {
      if (changes.showSwipeUp.currentValue) {
        this.isActive = true;
        this.fadeOut = false;
      } else {
        this.fadeOut = true;
        this.isActive = false;
        this.changeDetectorRef.detectChanges();
      }
      this.domManipulateService.setBodyScroll(!changes.showSwipeUp.currentValue);
    }
  }

  get borderRadius(): BorderRadiusDsType {
    return this.classType === SwipeType.FULL ? NoneBorderRadiusDs : SwipeBorderRadiusDs;
  }

  get surfaceHeight(): string {
    return this.classType === SwipeType.FULL ? '100vh' : 'auto';
  }

  get heightVh(): string {
    return this.heightPercentaje === 0 ? `${this.height}vh` : `${this.heightPercentaje}%`;
  }

  get showSubTitle(): boolean {
    return !!this.subTitle && this.subTitle.length > 0;
  }

  get headerWidgets(): HeaderWidgetConfig[] {
    return [
      {
        Type: HeaderWidgetType.Title,
        Label: this.title,
        LabelAlign: 'left'
      },
      {
        Type: HeaderWidgetType.Close,
      },
    ];
  }
}
